import React from 'react';

import { Bar, Container } from './styles';

interface ProgressBarInterface {
  value?: number;
  reverse?: boolean;
  color?: () => string;
}

const ProgressBar: React.FC<ProgressBarInterface> = ({
  value = 0,
  reverse,
  color
}) => {
  return (
    <Container>
      <Bar
        testID="barView"
        value={reverse ? 100 - value : value}
        color={color}
      />
    </Container>
  );
};

export default ProgressBar;
